import { render, staticRenderFns } from "./newsItemPageTpl.vue?vue&type=template&id=f5c60f02&"
import script from "./newsItemPageTpl.vue?vue&type=script&lang=js&"
export * from "./newsItemPageTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports